import type { FC } from "react";
import React from "react";

import { ChainID } from "../../types/token";
import RedirectLink from "../RedirectLink/RedirectLink";

export type ExplorerLinkProps = {
  address: string;
  type: "address" | "tx" | "account";
  style?: React.CSSProperties;
  children?: React.ReactNode;
};

const EXPLORER_URL = process.env.REACT_APP_EXPLORER_URL ?? "https://solscan.io";

export const ExplorerLink: FC<ExplorerLinkProps> = ({ address, type, style, children }) => {
  let chainID = ChainID.MainnetBeta;
  const storedConnectionState = localStorage.getItem("connectionEndpts");
  if (storedConnectionState?.includes("devnet")) {
    chainID = ChainID.Devnet;
  }

  let fullExplorerUrl = `${EXPLORER_URL}/${type}/${address}`;
  if (chainID === ChainID.Devnet) {
    fullExplorerUrl = `${fullExplorerUrl}?cluster=devnet`;
  }

  return (
    <RedirectLink href={fullExplorerUrl} title={address} style={style}>
      {children}
    </RedirectLink>
  );
};
